const KEY = 'nd:article-referrer';
const TTL_MS = 30 * 60 * 1000;

// The article lives at /blogs/:slug; the contact form is a hash section on /.
// sessionStorage rather than a query parameter, so shared URLs stay clean, the
// value survives the hash navigation, and it dies with the tab.
//
// Known slack: read, click the CTA, browse elsewhere, then submit 20 minutes
// later via the nav — still attributed to that article. The TTL bounds it. This
// is attribution, not accounting.
export function rememberArticleReferrer(slug: string): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ slug, ts: Date.now() }));
  } catch {
    /* private browsing — an enquiry still has to submit */
  }
}

export function consumeArticleReferrer(): string {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return 'direct';
    sessionStorage.removeItem(KEY);

    const { slug, ts } = JSON.parse(raw) as { slug?: string; ts?: number };
    if (!slug || typeof ts !== 'number') return 'direct';
    if (Date.now() - ts > TTL_MS) return 'direct';
    return slug;
  } catch {
    return 'direct';
  }
}
